import React from 'react'
import { BottomSheet } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'
import { observer } from 'mobx-react-lite'
import UserStore from '../../stores/UserStore'
import LoadingIndicator from '../atoms/loadingIndicator'
import backendApis from '../../utils/backendApis'

const NudgeBottomsheet = observer(() => {
  const onDismiss = () => {
    setTimeout(() => {
      UserStore.setBottomsheetOpened(false)
    }, 50)
  }

  const onClickHandler = async () => {
    window.gtag('event', 'clicked_install_CTA', {
      event_category: 'engagement',
      event_label: 'nudge_bottomsheet',
    })
    // navigate('/use-app')

    const savedLink = localStorage.getItem('toon_nudge_link_v2')
    if (savedLink) {
      window.open(savedLink, '_blank')
    } else {
      const dynamicLink = await backendApis.createDynamicLink()
      localStorage.setItem('toon_nudge_link_v2', dynamicLink?.data?.link)
      window.open(dynamicLink?.data?.link, '_blank')
    }
  }

  if (!UserStore.isLoaded) {
    return <LoadingIndicator isLoading />
  }
  return (
    <>
      {UserStore.bottomsheetOpened && (
        <button
          type="button"
          className="absolute top-0 w-full h-full bg-black opacity-80 z-30"
          onClick={onDismiss}
        />
      )}
      <BottomSheet
        className="absolute bottom-0 z-40 w-full border-none outline-none text-center"
        blocking={!UserStore.bottomsheetOpened}
        onDismiss={onDismiss}
        scrollLocking={false}
        open={UserStore.bottomsheetOpened}
      >
        <div className="flexCol items-center py-[6vw]">
          <img src="/images/toon/AppLogo.png" alt="" className="w-[24vw] h-[24vw] mx-auto" />

          <div className="h-[4vw]" />

          <div className="text-[5.4vw] font-bold">
            앱을 사용하면 더욱 다양한 작품들을 <br /> 편하게 보실 수 있어요!
          </div>

          <div className="h-[6vw]" />

          <button
            type="button"
            className="w-[70vw] py-[3vw] bg-[#F8323E] text-white text-[5vw] font-bold rounded-full"
            onClick={onClickHandler}
          >
            앱에서 보기
          </button>
          <button
            type="button"
            className="w-[80vw] mt-[1vw] py-[4vw] text-[#BCBDC3] text-[4vw] font-semibold"
            onClick={onDismiss}
          >
            괜찮아요, 오늘은 그냥 볼게요
          </button>
        </div>
      </BottomSheet>
    </>
  )
})

export default NudgeBottomsheet
